import { NoticeTypes } from '@genial/components';

export const genialLimitExplanation =
  'O valor informado para o limite genial é a soma entre os investimentos (com deságio), e o saldo em conta.';

export const totalAllocatedExplanation =
  'O valor informado é referente a soma entre valor alocado no cartão + Trader Cockpit';

export const genialLimitNoticeTexts: NoticeTypes.Props['textObjects'] = [
  {
    text: 'Atenção:',
    variant: 'semibold',
  },
  {
    text: ' Alguns investimentos, como PREVIDÊNCIA e CRA, não serão incluídos no limite Genial, e os produtos contemplados estarão sujeitos a deságio.',
    variant: 'regular',
  },
];

export const availableBalanceNormalizedExplanation =
  'Alocação do limite Genial: caso o cliente opte por incluir o saldo em conta, este valor ficará bloqueado para saque, mas disponível para investir.';
